import React from 'react';
import './card.css';
import automotive from "../../assets/valvo.jpg";

const Card = ({data}) => {
    return(
        <div className='card-container'>
            <div>
                <center><img src={automotive} /></center>
                <h4>{data.title}</h4>
                <p>{data.description}</p>
            </div>
            <button ><a href="tel:+919342943399">📞 Click Here</a><p> to call us now for more info</p></button>
        </div>
    );
};

export default Card;